import useGetItem from "./hooks/useGetItem";
import { useParams } from "react-router-dom";
import useDelete from "./hooks/useDelete";
import useUpdate from "./hooks/useUpdate";
import { CategoryFaqGql } from "data/queries/ApiCMS/CategoriesFaq/QueryCategoryFaq";
import { GenericMethods } from "../GenericMethods";
import { CategoryFaqMutationUpdateGql } from "data/queries/ApiCMS/CategoriesFaq/MutationUpdate";
import { Sites } from "data/utils/globals";

function Update() {
  const id = Number(useParams()?.id);

  if (!id) return null;

  return (
    <GenericMethods.Update<CategoryFaqGql["CategoryFaq"], CategoryFaqMutationUpdateGql>
      siteId={Sites.UNIFTEC.id}
      sitePath={Sites.UNIFTEC.path}
      redirectPath="/faq-categorias"
      useDelete={useDelete}
      useGetItem={useGetItem}
      useUpdate={useUpdate}
      queryParam={id}
    />
  );
}

export default Update;
